// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grid-container[data-v-6c6f3e21] {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-gap: 1.25rem;\n}\n@media only screen and (max-width: 950px) {\n.grid-container[data-v-6c6f3e21] {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n    grid-gap: 1.25rem;\n}\n}", ""]);
// Exports
module.exports = exports;
